import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ChevronLeft: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 7 11'>
      <path
        d='M0 5.51085L5.01444 0.647005C5.17539 0.48928 5.39262 0.398242 5.62079 0.392883C5.73676 0.392881 5.85158 0.415243 5.95864 0.458677C6.06571 0.502111 6.1629 0.565758 6.24462 0.645959C6.32634 0.72616 6.39097 0.821328 6.4348 0.92598C6.47862 1.03063 6.50078 1.14271 6.49998 1.25574C6.49673 1.47743 6.40545 1.68926 6.24532 1.84673L2.47993 5.51676L6.24532 9.18091C6.40439 9.33907 6.49548 9.55047 6.49998 9.7719C6.49673 9.99359 6.40545 10.2054 6.24532 10.3629C6.07718 10.5197 5.85347 10.6072 5.62079 10.6072C5.3881 10.6072 5.16439 10.5197 4.99626 10.3629C4.82812 10.2061 0 5.51085 0 5.51085Z'
        fill={props.fill}
      />
    </SvgIcon>
  );
};
